import React from "react";
import * as R from "ramda";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Button from "../../../../modules/commons/Button";

export const formGroup = {
  packageId: { value: "" },
  packageName: { value: "", mandatory: true },
  allCabang: { value: null },
  kodeCabang: { value: [] },
  kodeVariant: { value: [], mandatory: true },
  startDate: { value: null },
  endDate: { value: null },
  gracePeriod: { value: 0 },
  hasGracePeriod: { value: false },
  part: { value: [] },
  service: { value: [] },
  // status: { value: "ACTIVE" },
};

export const initialDataDetail = {
  category: null,
  kode: null,
  name: null,
  satuan: null,
  jumlah: null,
  saved: false,
};

export const tableColumns = {
  mainPage: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "packageId",
      label: "Paket ID",
    },
    {
      name: "packageName",
      label: "Nama Paket",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "kodeCabang",
      label: "Cabang Berlaku",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "kodeVariant",
      label: "Kode Varian",
      options: {
        customBodyRender: (val) => <p>{!R.isEmpty(val) ? val : "-"}</p>,
        sort: false,
      },
    },
    {
      name: "startPeriod",
      label: "Tgl Mulai",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "endPeriod",
      label: "Tgl Selesai",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "hasGracePeriod",
      label: "No Periode",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "period",
      label: "Grace Periode",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
  ],
  detailPage: (
    handleSaveRow,
    handleEditRow,
    handleCancelRow,
    handleDeleteRow,
    handleValueChange,
    handleCategoryChange,
    handleItemChange,
    dataCategory,
    dataItem,
    validationErrors,
    tab
  ) => {
    return {
      Job: jobDetailColumns(
        handleSaveRow,
        handleEditRow,
        handleCancelRow,
        handleDeleteRow,
        handleValueChange,
        handleCategoryChange,
        handleItemChange,
        dataCategory,
        dataItem,
        validationErrors
      ),
      Part: partDetailColumns(
        handleSaveRow,
        handleEditRow,
        handleCancelRow,
        handleDeleteRow,
        handleValueChange,
        handleCategoryChange,
        handleItemChange,
        dataCategory,
        dataItem,
        validationErrors
      ),
    };
  },
};

const jobDetailColumns = (
  handleSaveRow,
  handleEditRow,
  handleCancelRow,
  handleDeleteRow,
  handleValueChange,
  handleCategoryChange,
  handleItemChange,
  dataCategory,
  dataItem,
  validationErrors
) => [
  {
      name: "",
      label: "No",
      options: {
          customBodyRender: (value, tableMeta) => {
              return <>{tableMeta.rowIndex + 1}</>;
          },
          sort: false,
      },
  },
  {
    name: "serviceCode",
    label: "Kode Job/Jasa*",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["serviceCode"];
        const optionsJob = []
          .concat(...Object.values(dataItem?.Job || {}))
          .map((item) => ({
            value: item.value,
            label: `${item.value} - ${item.label}`,
            original: item,
          }));

        return isSaved ? (
          <p>{val?.label || val?.value}</p>
        ) : (
          <>
            <SimpleDDL
              id={`ddl_serviceCode_${tableMeta.rowIndex}`}
              name="serviceCode"
              containerclassname="margin-bottom-10px width width-250px"
              box="search"
              isClearable
              value={val ? { value: val.value, label: val.value } : null}
              options={optionsJob}
              // onChange={(value, { name }) =>
              //   handleItemChange(tableMeta.rowIndex, name, value.original)
              // }
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              onChange={(value, { name }) =>
                handleItemChange(
                  tableMeta.rowIndex,
                  name,
                  value ? value.original : null
                )
              }
            />
            {errorMsg && (
              <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
            )}
          </>
        );
      },
    },
  },
  {
    name: "serviceName",
    label: "Nama Job/Jasa*",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["serviceName"];
        const optionsJob = []
          .concat(...Object.values(dataItem?.Job || {}))
          .map((item) => ({
            value: item.value,
            label: item.label,
            original: item,
          }));

        return isSaved ? (
          <p>{val?.label || val?.value}</p>
        ) : (
          <>
            <SimpleDDL
              id={`ddl_serviceName_${tableMeta.rowIndex}`}
              name="serviceName"
              containerclassname="margin-bottom-10px width width-250px"
              box="search"
              isClearable
              value={val}
              options={optionsJob}
              // onChange={(value, { name }) =>
              //   handleItemChange(tableMeta.rowIndex, name, value.original)
              // }
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              onChange={(value, { name }) =>
                handleItemChange(
                  tableMeta.rowIndex,
                  name,
                  value ? value.original : null
                )
              }
            />
            {errorMsg && (
              <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
            )}
          </>
        );
      },
    },
  },
  {
    name: "serviceCategory",
    label: "Kategori Service",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["serviceCode"];
        return isSaved ? (
          <p>{val}</p>
        ) : (
          <>
            <SimpleInput
              containerclassname="width width-250px"
              readOnly
              value={val || "-"}
            />
            {errorMsg && <p style={{ fontSize: "12px" }}></p>}
          </>
        );
      },
    },
  },
  {
    name: "estimationTime",
    label: "Estimasi Waktu (menit)",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["serviceCode"];
        return isSaved ? (
          <p>{val}</p>
        ) : (
          <>
            <SimpleInput
              containerclassname="width width-250px"
              readOnly
              value={val ?? ""}
              box="onlyNumber"
            />
            {errorMsg && <p style={{ fontSize: "12px" }}></p>}
          </>
        );
      },
    },
  },
  {
    name: "saved",
    label: "Action",
    options: {
      customBodyRender: (val, tableMeta) =>
        renderActionButtons(
          val,
          tableMeta,
          handleSaveRow,
          handleEditRow,
          handleCancelRow,
          handleDeleteRow
        ),
    },
  },
];

const partDetailColumns = (
  handleSaveRow,
  handleEditRow,
  handleCancelRow,
  handleDeleteRow,
  handleValueChange,
  handleCategoryChange,
  handleItemChange,
  dataCategory,
  dataItem,
  validationErrors
) => [
  {
      name: "",
      label: "No",
      options: {
          customBodyRender: (value, tableMeta) => {
              return <>{tableMeta.rowIndex + 1}</>;
          },
          sort: false,
      },
  },
  {
    name: "kodePart",
    label: "Kode Part*",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["kodePart"];
        const flatOptions = [].concat(...Object.values(dataItem?.Part || {}));
        const mappedOptions = flatOptions.map((item) => ({
          value: item.value,
          label: `${item.value} - ${item.label}`,
          original: item,
        }));

        return isSaved ? (
          <p>{val?.label}</p>
        ) : (
          <>
            <SimpleDDL
              id={`ddl_kodePart_${tableMeta.rowIndex}`}
              name="kodePart"
              containerclassname="margin-bottom-10px width width-250px"
              box="search"
              value={val}
              isClearable
              options={mappedOptions}
              // onChange={(value, { name }) =>
              //   handleItemChange(tableMeta.rowIndex, name, value)
              // }
              onChange={(value, { name }) =>
                handleItemChange(
                  tableMeta.rowIndex,
                  name,
                  value ? value.original : null
                )
              }
            />
            {errorMsg && (
              <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
            )}
          </>
        );
      },
    },
  },
  {
    name: "partName",
    label: "Nama Part*",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["partName"];
        const flatOptions = [].concat(...Object.values(dataItem?.Part || {}));
        const mappedOptions = flatOptions.map((item) => ({
          value: item.value,
          label: item.label,
          original: item,
        }));

        return isSaved ? (
          <p>{val?.label}</p>
        ) : (
          <>
            <SimpleDDL
              id={`ddl_partName_${tableMeta.rowIndex}`}
              name="partName"
              containerclassname="margin-bottom-10px width width-250px"
              box="search"
              isClearable
              value={val}
              options={mappedOptions}
              // onChange={(value, { name }) =>
              //   handleItemChange(tableMeta.rowIndex, name, value)
              // }
              onChange={(value, { name }) =>
                handleItemChange(
                  tableMeta.rowIndex,
                  name,
                  value ? value.original : null
                )
              }
            />
            {errorMsg && (
              <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
            )}
          </>
        );
      },
    },
  },
  {
    name: "partCategory",
    label: "Kategori",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["kodePart"];
        return isSaved ? (
          <p>{val}</p>
        ) : (
          <>
            <SimpleInput
              containerclassname="width width-250px"
              readOnly
              value={val || "-"}
            />
            {errorMsg && <p style={{ fontSize: "12px" }}></p>}
          </>
        );
      },
    },
  },
  {
    name: "satuan",
    label: "Satuan",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["kodePart"];
        return isSaved ? (
          <p>{val}</p>
        ) : (
          <>
            <SimpleInput
              containerclassname="width width-250px"
              readOnly
              value={val || "-"}
            />
            {errorMsg && <p style={{ fontSize: "12px" }}></p>}
          </>
        );
      },
    },
  },
  {
    name: "partQty",
    label: "Jumlah*",
    options: {
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData.at(-1);
        const errorMsg = validationErrors?.["partQty"];
        return isSaved ? (
          <p>{val}</p>
        ) : (
          <>
            <SimpleInput
              name="partQty"
              containerclassname="margin-bottom-10px width width-250px"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                handleValueChange(tableMeta.rowIndex, target.name, target.value)
              }
            />
            {errorMsg && (
              <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
            )}
          </>
        );
      },
    },
  },
  {
    name: "saved",
    label: "Action",
    options: {
      customBodyRender: (val, tableMeta) =>
        renderActionButtons(
          val,
          tableMeta,
          handleSaveRow,
          handleEditRow,
          handleCancelRow,
          handleDeleteRow
        ),
    },
  },
];

const renderActionButtons = (
  val,
  tableMeta,
  handleSaveRow,
  handleEditRow,
  handleCancelRow,
  handleDeleteRow
) => (
  <FlexView vAlignContent="center" style={{ gap: 10 }}>
    {val ? (
      <>
        <Button
          className="btnAct"
          onClick={() => handleEditRow(tableMeta.rowIndex)}
        >
          <i
            className="fa fa-pencil-alt"
            style={{
              fontSize: 20,
              color: "red",
            }}
          />
        </Button>
        <Button
          className="btnAct"
          onClick={() => handleDeleteRow(tableMeta.rowIndex)}
        >
          <i
            className="fa fa-times-circle"
            style={{
              fontSize: 20,
              color: "red",
            }}
          />
        </Button>
      </>
    ) : (
      <>
        <Button
          className="btnAct"
          onClick={() => handleSaveRow(tableMeta.rowIndex)}
        >
          <i
            className="fa fa-save"
            style={{
              fontSize: 20,
              color: "red",
            }}
          />
        </Button>
        <Button
          className="btnAct"
          onClick={() => handleCancelRow(tableMeta.rowIndex)}
        >
          <i
            className="fa fa-times-circle"
            style={{
              fontSize: 20,
              color: "red",
            }}
          />
        </Button>
      </>
    )}
  </FlexView>
);
